import { render } from "./EmissionSource.vue?vue&type=template&id=798872b2"
import script from "./EmissionSource.vue?vue&type=script&lang=js"
export * from "./EmissionSource.vue?vue&type=script&lang=js"

import "./EmissionSource.vue?vue&type=style&index=0&id=798872b2&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__